import { render } from "./project-place.vue?vue&type=template&id=4223acd0&scoped=true&ts=true"
import script from "./project-place.vue?vue&type=script&lang=ts"
export * from "./project-place.vue?vue&type=script&lang=ts"

import "./project-place.vue?vue&type=style&index=0&id=4223acd0&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4223acd0"]])

export default __exports__